import * as React from 'react';

import { gql, useMutation } from '@apollo/client';

import { Button } from '@chakra-ui/react';
import { GET_USER } from '../../../hooks/useAuth';
import { navigate } from 'gatsby';

const LOG_OUT = gql`
  mutation logOut {
    logout(input: {}) {
      status
    }
  }
`;

const LogOut: React.FC = () => {
  const [logOut, { loading }] = useMutation(LOG_OUT, {
    refetchQueries: [{ query: GET_USER }],
  });

  function handleClick() {
    logOut();
    navigate('/prijavite-se');
  }

  return (
    <Button
      onClick={() => handleClick()}
      variant="solid"
      w={{ base: '100%', md: 'auto' }}
    >
      {loading ? 'Одјављивање...' : 'Одјавите се'}
    </Button>
  );
};

export default LogOut;
